export const SUBMISSION_CLEAR_ERROR = 'SUBMISSION_CLEAR_ERROR';
export const SUBMISSION_REQUEST = 'SUBMISSION_REQUEST';
export const SUBMISSION_SAVE = 'SUBMISSION_SAVE';
export const SUBMISSION_SUCCESS = 'SUBMISSION_SUCCESS';
export const SUBMISSION_FAILURE = 'SUBMISSION_FAILURE';
export const SUBMISSION_RESET = 'SUBMISSION_RESET';
